
























































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import { Severity } from '@sentry/types';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { Doctor } from '@/plugins/podolib/services/doctor';

import CompositeCardV2 from '@/components/composite/CompositeCardV2.vue';
import AccountOfficeAddOrEdit from '@/components/account/AccountOfficeAddOrEdit.vue';

@Component({
  components: {
    CompositeCardV2,
    AccountOfficeAddOrEdit,
  },
})
export default class AccountOffices extends Vue {
  @Prop({ required: true }) private doctor!: TEntity<Doctor>;

  @Provide() private pending: boolean = false;
  @Provide() private success: boolean = false;
  @Provide() private successTimeout: any = null;
  @Provide() private error: Error | null = null;

  @Watch('success')
  onSuccessChange(state: boolean) {
    if (this.successTimeout) clearTimeout(this.successTimeout);
    if (state) {
      this.successTimeout = setTimeout(() => {
        this.success = false;
      }, 3000);
    }
  }

  async selectOffice(_id: string) {
    if (this.pending) return;

    const data = {
      offices: {
        items: this.doctor.offices.items,
        selected: _id,
      },
    };

    const previous = this.doctor.offices.selected;

    try {
      // Reset flags
      this.success = false;
      this.error = null;

      // Set 'pending' flag
      this.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        params: {
          _id: this.$pdc.doctor!.current._id,
        },
        data,
      });
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess(
        'User DefaultOfficeSelected',
        {
          officeId: _id,
        },
        previous,
      );

      this.success = true;
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure(
        'User DefaultOfficeSelected',
        e,
        {
          officeId: _id,
        },
        previous,
      );
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.pending = false;
    }
  }

  async deleteOffice(_id: string) {
    if (this.pending) return;

    const data = {
      offices: {
        ...this.doctor.offices,
        items: this.doctor.offices.items.filter((x) => x._id !== _id),
      },
    };

    try {
      // Reset flags
      this.success = false;
      this.error = null;

      // Set 'pending' flag
      this.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        params: {
          _id: this.$pdc.doctor!.current._id,
        },
        data,
      });
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('User OfficeDeleted', {
        officeId: _id,
      });

      this.success = true;
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('User OfficeDeleted', e, {
        officeId: _id,
      });
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.pending = false;
    }
  }
}
